<template>
  <div class="message chat-message animate slideInUp d-flex">
    <div class="">
      <img
        :src="chatImageUrl"
        alt="Chatbot | PLI"
        width="100%"
        height="auto"
        class="img-circle avatar"
        :style="!show_avatar ? 'opacity:0' : 'opacity:100'"
      />
    </div>

    <div class="flex-grow-1 pl-2">
      <info-popup-endorsements v-if="showInfoPopup"></info-popup-endorsements>
      <div
        class="message-box"
        v-html="getMessage()"
        :style="
          is_alert === true
            ? 'border: 2px solid #00a99d; background-color: #fff; border-radius:4px'
            : ''
        "
      >
        {{ getMessage() }}
      </div>

    </div>
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */
import store from "../../store";
import { mapState, mapActions, mapGetters } from "vuex";
import { EventBus } from "../../event-bus";
import Cookies from "js-cookie";
import * as appConfigs from "../../configs";
import axios from "axios";
import queryString from "query-string";
import VueScrollTo from "vue-scrollto";
import { isEmpty, includes } from "lodash";



/**
 * Import local components
 */

export default {
  props: ["message", "type_val", "show_avatar", "is_alert", "awaitVariable", "index", "messageInstance"],
  data() {
    return {
      showInfoPopup: false,
    }
  },
  store,
  components: {
  },
  mounted() {
    // this.initializeReminderToken();
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      orderId: (state) => state.orderId, // 3026
      summaryData: (state) => state.summaryData,
      pendingOrder: (state) => state.pendingOrder,
      selectedOccupation: (state) => state.selectedOccupation,
      underwriter: (state) => state.underwriter,
      accidentCover: (state) => state.accidentCover,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      unavailableOccupations: (state) => state.unavailableOccupations,
      calculating: (state) => state.calculating
    }),
    ...mapGetters(["totalCostOfInsurance", "cheapestCostUnderwriterName"]),

    showSidebar() {
      return this.step >= 5;
    },

    showInReferral() {
      return (
        Cookies.get("convertFromReferral") != this.pendingOrder.id &&
        this.pendingOrder.in_referral
      );
    },

    showUnavailableOccupation() {
      if (
        this.step >= 3 &&
        this.prevStep >= 2 &&
        (includes(
          this.unavailableOccupations,
          this.pendingOrder.occupation_id
        ) ||
          this.pendingOrder.current_annual_revenue > 2500000 ||
          this.pendingOrder.status == "HS")
      ) {
        // Cleaning the pendingOrderId because
        // after the thank you page, user should be able to fill out the form again
        Cookies.remove("pendingOrderId");
        return true;
      }

      return false;
    },
    chatImageUrl() {
      if (this.type_val === "male") {
        return appConfigs.apiDomain + "images/male-cropped.jpg";
      } else {
        return appConfigs.apiDomain + "images/female-cropped.jpg";
      }
    },

    chatImageGifUrl() {
      return appConfigs.apiDomain + "images/chat-loader.svg";
    },

    eFundInterestRate() {
      return appConfigs.eFundInterestRate;
    },
    adjustedTotal() {
      if (isEmpty(this.summaryData)) {
        return 0;
      }

      let total = this.summaryData.totalPrice || 0;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }
      return (total * this.eFundInterestRate).toFixed(2);
    },
    monthlyPayments() {
      if (
        isEmpty(this.pendingOrder) ||
        this.pendingOrder.period_of_cover != 12
      ) {
        return 0;
      }
      let monthlyPayments = (this.adjustedTotal / 10).toFixed(2);
      return monthlyPayments;
    },
    accidentCoverPDS() {
      return appConfigs.accidentCoverPDS;
    },
  },

  methods: {

    
    scrollTo() {
      VueScrollTo.scrollTo(this.$el, 500, {
        offset: -200,
      });
    },
    getMessage() {
      if (this.message) {
        var message = this.message;
        if (message.includes("{totalPrice}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
        }

        if (message.includes("{monthlyPayments}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
        }

        if (message.includes("{underwriter}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
        }

        if (message.includes("{endorsements}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });

        }

        if (message.includes("{policyWording}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
        }

        if (message.includes("{policyWording}") > 0) {
          message = this.fixVariables(message);
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
        }
       
        if (message.includes("{infoPopup}") > 0) {
          message = message.replace("{infoPopup}", '');
          this.messageInstance.content = message;
          this.$store.commit("setCalculating", { calculating: false });
          this.showInfoPopup = true;
        }

        if(message.includes("{") > 0){
          var chatImageGifUrl = this.chatImageGifUrl;
          message =` <img src="`+chatImageGifUrl+`" width="30px" />`;
          this.$store.commit("setCalculating", { calculating: true });
        }
        
        this.$emit("updateMessage", this.messageInstance, this.index);
        this.$emit("scrollToBottom");
        return message; 
        
      }else{
        return '';
      }
    },
    fixVariables(message) { // fixing variables in system messages
      if (this.totalCostOfInsurance && this.totalCostOfInsurance !== null) {
        let totalCostOfInsuranceFloat = parseFloat(this.totalCostOfInsurance);
        message = message.replace(
          "{totalPrice}",
          "$" + totalCostOfInsuranceFloat.toFixed(2)
        );
      }
      
      if (this.monthlyPayments && this.monthlyPayments !== null) {
        let monthlyPaymentsFloat = parseFloat(this.monthlyPayments);
        if (
          monthlyPaymentsFloat !== undefined &&
          monthlyPaymentsFloat !== NaN &&
          monthlyPaymentsFloat !== 0
        ) {
          message = message.replace(
            "{monthlyPayments}",
            "$" + monthlyPaymentsFloat.toFixed(2)
          );
        } else {
          message = message.replace(" or {monthlyPayments} per month.", ".");
        }
      }


      if (this.cheapestCostUnderwriterName && this.cheapestCostUnderwriterName !== null) {
        message = message.replace(
          "{underwriter}",
          this.cheapestCostUnderwriterName
        );
      }

      if (this.pendingOrder && this.pendingOrder.endorsements && this.pendingOrder.endorsements !== null) {
        var endorsements = `<p class="my-1">Endorsements:</p> <ul>`;

        if(this.pendingOrder.endorsements && this.pendingOrder.endorsements.length == 0){
          endorsements += `<li>None</li>`;
        }else{
          this.pendingOrder.endorsements.forEach(endorsement => {
              endorsements += `<li>
                  `+endorsement.description+`
                </li>`;
          });
        }
         
        endorsements += `</ul>`;
        message = message.replace(
          "{endorsements}",
          endorsements
        );
      }

      if (this.pendingOrder.id && this.pendingOrder.id !== null) {
        let url = "/"+this.pendingOrder.id+"/policy-wording";
        let policyWordingLink = `<a
                        target="_blank"
                        rel="noopener noreferrer" class="cursor-pointer"
                        style="color:#2CA8FF;"
                        href=`+url+`
                        >Policy Wording</a>`;

        message = message.replace(
          "{policyWording}",
          policyWordingLink
        );
      }

      return message;
    },

   
  },
};
</script>

<style>
.message {
  padding: 0.25rem 1rem;
}
.avatar {
  border: 1px solid #dedede;
}
.message-box {
  border: 1px solid #dedede;
  background-color: #f1f0f0;
  padding: 10px;
  color: #000;
  margin-top: 3px;
  border-radius: 0px 15px 15px;
  width: fit-content;
  max-width: 60%;
  font-size: 16px;
  line-height: 26px;
}

.message-box a:hover{
  color: #009245 !important;

}
@media screen and (max-width: 768px) {
  .message {
    padding: 5px !important;
  }

  .message-box {
    max-width: 100%;
    font-size: 14px;
  }
  .avatar{
    margin-right: 2px !important;
  }
}
</style>
    